module.exports = __webpack_public_path__ + "static/splash-on.675a9fc7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/simple/ScreenButton/splash-on.svg
// module id = 336
// module chunks = 168707334958949